import { Component, OnInit } from '@angular/core';
import { EventAggregator, SearchConfig, tr, Types, ViewType, KeyBase, OverviewMain } from '@kpd/framework-ngx';
import { Tenant } from 'app/shared/models/tenant';
import { TenantService } from 'app/shared/services/tenant.service';
import { PermissionFacade } from 'app/shared/services/facades/permission.facade';
import { PermissionsNavigatorHelper } from 'app/permissions/permissions-navigator-helper';
import { Permissions } from 'app/shared/services/permissions';

@Component({
  selector: 'app-permissions-overview',
  templateUrl: './permissions-overview.component.html',
})
export class PermissionsOverviewComponent extends OverviewMain implements OnInit {
  Permissions: typeof Permissions = Permissions;
  columnsConfig = this.createColumnsConfig();
  searchConfig = this.createPermissionSearchConfig();
  viewType = ViewType.Table;
  selectedItemIds: KeyBase[] = [];
  tenant: Tenant = new Tenant();
  ViewTypes = ViewType;

  constructor(
    public navigatorHelper: PermissionsNavigatorHelper,
    public entityFacade: PermissionFacade,
    public eventAggregator: EventAggregator,
    private tenantService: TenantService,
  ) {
    super();
  }

  ngOnInit(): void {
    super.ngOnInit();

    this.tenantService.getTenant().subscribe((tenant: Tenant) => {
      this.tenant = tenant;
    });

    this.entityFacade.viewType$.subscribe((result) => {
      this.viewType = result;
    });
  }

  onToggleViewType(): void {
    this.entityFacade.changeViewType(this.viewType === ViewType.Table ? ViewType.Card : ViewType.Table);
  }

  createPermissionSearchConfig(): any {
    return new SearchConfig({
      multipleCriteria: true,
      fields: [
        { field: 'application', displayValue: tr('Application'), dataType: Types.String },
        { field: 'name', displayValue: tr('Name'), dataType: Types.String },
        { field: 'description', displayValue: tr('Description'), dataType: Types.String },
      ],
    });
  }

  createColumnsConfig(): any[] {
    return [
      { field: 'application', header: tr('Application'), width: '25%' },
      { field: 'name', header: tr('Name'), width: '25%', type: 'link' },
      { field: 'description', header: tr('Description') },
    ];
  }
}
